import React from 'react';
import Moment from 'moment-timezone';
import EndorsementCard from 'Components/Common/EndorsementCard';
import EndorsementDto from 'Models/Endorsement/Dto/EndorsementDto';

interface CurrentEndorsementPanelProps {
   endorsements: readonly EndorsementDto[];
   futureEndorsements?: readonly EndorsementDto[];
}

const getEndorsementYearRange = (endorsement: EndorsementDto): string | null => {
   if (!endorsement.startDate || !endorsement.expiryDate) return null;
   const startYear = Moment(endorsement.startDate).year();
   const expiryYear = Moment(endorsement.expiryDate).format('YY');
   return `${startYear}-${expiryYear}`;
};

const CurrentEndorsementPanel = ({
   endorsements,
   futureEndorsements,
}: Readonly<CurrentEndorsementPanelProps>): JSX.Element => {
   const currentYearRange = endorsements.length > 0 ? getEndorsementYearRange(endorsements[0]) : null;
   const futureYearRange = futureEndorsements && futureEndorsements.length > 0 ? getEndorsementYearRange(futureEndorsements[0]) : null;

   return (
      <div className="md-grid md-cell--12">
         <div className="md-cell md-cell--6">
            <div className="md-grid md-cell--12 center-cards">
               <div className="endorsement-badges-section">
                  {endorsements.map(endorsement => (
                     <EndorsementCard
                        key={endorsement.endorsementId}
                        endorsement={endorsement}
                     />
                  ))}
               </div>
            </div>
            {currentYearRange && <h1 className="year-footer">{currentYearRange}</h1>}
         </div>
         {futureEndorsements && futureEndorsements.length > 0 && (
            <div className="md-cell md-cell--6">
               <div className="md-grid md-cell--12 center-cards">
                  <div className="endorsement-badges-section">
                     {futureEndorsements.map(endorsement => (
                        <EndorsementCard
                           key={endorsement.endorsementId}
                           endorsement={endorsement}
                        />
                     ))}
                  </div>
               </div>
               {futureYearRange && <h1 className="year-footer">{futureYearRange}</h1>}
            </div>
         )}
      </div>
   );
};

export default CurrentEndorsementPanel;
